module.exports = __webpack_public_path__ + "images/avatars/female/12.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/avatars/female/12.png
// module id = x0FM
// module chunks = 55